import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const HelpdeskIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize?.width ?? "24"}
      height={finalSize?.height ?? "24"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.71332 15.1334C2.15332 15.1334 0.833322 13.8134 0.833322 12.2534V8.1467C0.799989 6.20003 1.51999 4.3667 2.86666 2.99337C4.21332 1.6267 6.01999 0.866699 7.96666 0.866699C11.94 0.866699 15.1667 4.10003 15.1667 8.0667V12.1734C15.1667 13.76 13.8733 15.0534 12.2867 15.0534C10.7267 15.0534 9.40666 13.7334 9.40666 12.1734V10.3C9.40666 9.33337 10.1667 8.57337 11.1333 8.57337C12.1 8.57337 12.86 9.33337 12.86 10.3V12.32C12.86 12.5934 12.6333 12.82 12.36 12.82C12.0867 12.82 11.86 12.5934 11.86 12.32V10.3C11.86 9.8467 11.4933 9.57337 11.1333 9.57337C10.68 9.57337 10.4067 9.94003 10.4067 10.3V12.1734C10.4067 13.1934 11.2667 14.0534 12.2867 14.0534C13.3067 14.0534 14.1667 13.1934 14.1667 12.1734V8.0667C14.1667 4.6467 11.3867 1.8667 7.96666 1.8667C6.29332 1.8667 4.73999 2.51337 3.57999 3.69337C2.41999 4.87337 1.79999 6.45336 1.83332 8.13337V12.2534C1.83332 13.2734 2.69332 14.1334 3.71332 14.1334C4.73332 14.1334 5.59332 13.2734 5.59332 12.2534V10.38C5.59332 9.9267 5.22666 9.65336 4.86666 9.65336C4.41332 9.65336 4.13999 10.02 4.13999 10.38V12.3267C4.13999 12.6 3.91332 12.8267 3.63999 12.8267C3.36666 12.8267 3.13999 12.6 3.13999 12.3267V10.38C3.13999 9.41337 3.89999 8.65336 4.86666 8.65336C5.83332 8.65336 6.59332 9.41337 6.59332 10.38V12.2534C6.59332 13.8134 5.27332 15.1334 3.71332 15.1334Z"
        fill="currentColor"
      />
      <path
        d="M7.93975 7.67342C7.80768 7.67169 7.6815 7.61846 7.5881 7.52506C7.49471 7.43166 7.44147 7.30549 7.43975 7.17342V7.03342C7.44787 6.76815 7.52382 6.50937 7.66037 6.2818C7.79691 6.05422 7.98949 5.86542 8.21974 5.73341C8.4664 5.56675 8.54642 5.45342 8.54642 5.28009C8.54642 5.11919 8.48249 4.96488 8.36872 4.85111C8.25495 4.73734 8.10064 4.67342 7.93975 4.67342C7.77885 4.67342 7.62454 4.73734 7.51077 4.85111C7.397 4.96488 7.33308 5.11919 7.33308 5.28009C7.33308 5.41269 7.2804 5.53987 7.18663 5.63364C7.09287 5.72741 6.96569 5.78009 6.83308 5.78009C6.70047 5.78009 6.57329 5.72741 6.47952 5.63364C6.38575 5.53987 6.33308 5.41269 6.33308 5.28009C6.33308 4.85397 6.50235 4.44531 6.80366 4.144C7.10497 3.84269 7.51363 3.67342 7.93975 3.67342C8.36586 3.67342 8.77453 3.84269 9.07583 4.144C9.37714 4.44531 9.54642 4.85397 9.54642 5.28009C9.53881 5.54121 9.46434 5.79603 9.33011 6.02014C9.19587 6.24425 9.00638 6.43016 8.77975 6.5601C8.51975 6.73343 8.43975 6.84676 8.43975 7.03342V7.17342C8.43975 7.30603 8.38707 7.43321 8.2933 7.52697C8.19953 7.62074 8.07235 7.67342 7.93975 7.67342Z"
        fill="currentColor"
      />
      <path
        d="M7.93975 9.33344C7.84086 9.33344 7.74418 9.30411 7.66196 9.24917C7.57973 9.19423 7.51566 9.11613 7.47781 9.02476C7.43997 8.9334 7.43006 8.83287 7.44935 8.73588C7.46864 8.63889 7.51627 8.54981 7.58619 8.47988C7.65612 8.40996 7.7452 8.36233 7.84219 8.34304C7.93918 8.32375 8.03973 8.33364 8.13109 8.37148C8.22246 8.40933 8.30054 8.47342 8.35548 8.55565C8.41042 8.63787 8.43975 8.73455 8.43975 8.83344C8.43975 8.96605 8.38707 9.09321 8.2933 9.18697C8.19954 9.28074 8.07236 9.33344 7.93975 9.33344Z"
        fill="currentColor"
      />
    </svg>
  );
};
const HelpdeskIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={HelpdeskIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default HelpdeskIcon;
